import React, { useEffect } from "react";
import { Card } from "../components/common/Card"; // 1. FIXED: Use named import { Card }
import { Link, useNavigate } from "react-router-dom";
// import { ROUTES } from "../constants/routes"; // 2. REMOVED: Unsafe import
import { useAuth } from "../context/AuthProvider";

const Login: React.FC = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user && !loading) {
      // 3. Redirect to Home, which handles role logic
      navigate("/");
    }
  }, [user, loading, navigate]);

  if (loading) return null; // Or show a spinner

  return (
    <div className="max-w-md mx-auto px-4 pt-8 pb-16 sm:py-16">
      <Card className="p-8">
        <p className="text-center mb-6 text-gray-600">
          Please sign up or log in with your phone number to continue
        </p>
        <div className="text-center">
          {/* 4. FIXED: Use direct path */}
		  <Link
		to="/signup"
		className="inline-block px-8 py-3 rounded bg-orange-600 text-white font-bold shadow hover:bg-orange-700 transition"
	> Continue with Phone number
	</Link>
        </div>
      </Card>
    </div>
  );
};

export default Login;